import type { AxiosInstance } from 'axios';

import { bffClient } from 'src/app/client/rest';
import useAuth from 'src/app/hooks/useAuth';

/**
 * @deprecated - Only use this file from within `src/app/hooks/data`.
 *
 * Sorry, I couldn't get `import/no-restricted-paths` or `no-restricted-imports` to work.
 */
export const useBffClient = (): AxiosInstance => {
  const { installAuthInterceptor } = useAuth();
  return installAuthInterceptor(bffClient);
};

export interface BFFResponse {
  config: Record<string, unknown>;
  request: Record<string, unknown>;
  status: number;
  statusText: string;
}
